import { type ArrivalState } from "@booking/booking/store/arrival/types";
import { createContext } from "react";
import { StoreApi } from "zustand";

export const ArrivalDateContext = createContext<StoreApi<ArrivalState> | null>(
  null,
);
